/**
 * 处理 UserId 的中间件
 * 在每一接口请求体注入当前登录用户的UserId
 */
import { TafMiddleware } from "../helper";
import { getUserId } from "@/api/getUserId";

export const userIdMiddleware: TafMiddleware = async (ctx, next) => {
  const reqInstance =
    typeof ctx.request.ReqClass === "function" ? new ctx.request.ReqClass() : null;
  if (reqInstance) {
    const keys = ["tId", "tUserId", "userId"];
    const hasUserIdKeys = keys.filter(key => reqInstance?.[key]);
    // 在这里填写不用注入的api。格式 `ui.方法名`
    const banApi: `${string}.${string}`[] = [`huyauserui.getUserProfile`];
    if (
      hasUserIdKeys.length &&
      !banApi.includes(`${ctx.request.moduleName}.${ctx.request.funcName}`)
    ) {
      // 为了避免重复请求，这里最好在Store里缓存UserId
      const userId = await getUserId();
      hasUserIdKeys.forEach(key => {
        if (!ctx.request.data) ctx.request.data = {};
        ctx.request.data[key] = userId;
      });
    }
  }

  // 调用下一个中间件
  await next();

  // 请求后逻辑（如果需要）
};
